<template>
  <b-modal
    ref="mc-modal"
    size="md"
    centered
    scrollable
    :title="$t('delivery.message.rescheduleDeliveryTitle')"
  >
    <div class="card-body p-2">
      <McAlert
        v-if="isPickedToRescheduled || entityData?.status?.name === 'Diambil'"
        class="mb-3"
        variant="warning"
        :html="rescheduleWarningHtml"
        withIcon
        :withGap="false"
      />
      <p v-html="confirmationHtml"></p>
      <p v-html="statusChangeHtml"></p>

      <FormulateForm
        v-model="formValues"
        name="reason-form"
        @submit="handleSubmit"
        @failed-validation="handleFailedValidation"
      >
        <FormulateInput
          type="select-resourceful"
          name="reason-id"
          trackBy="id"
          validation="required"
          :label="$t('delivery.fields.reason')"
          :placeholder="$t('delivery.placeholder.rescheduleReason')"
          :help="true"
          :optionLabelFn="({ item }) => item.reason"
          :optionsGetter="reasonGet"
          :validation-messages="{
            required: $t('global.validation.required'),
          }"
        />
      </FormulateForm>
    </div>

    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0 gap-2">
        <McButton variant="secondary" :text="$t('global.cancel')" @click="cancel" />
        <McButton
          :text="$t('delivery.message.rescheduleDeliveryButton')"
          :disabled="disabled"
          @click="triggerSubmit"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import * as Reason from '@/services/rest-api/lib/delivery/reason'
import McButton from '@/components/McButton'
import McAlert from '@/components/McAlert'

export default {
  components: {
    McButton,
    McAlert,
  },
  props: {
    entityData: {
      required: true,
    },
    newStatusTransition: {
      required: true,
    },
    isPickedToRescheduled: {
      type: Boolean,
      default: false,
    },
    isFromList: {
      type: Boolean,
      default: false,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['transition'],
  data() {
    return {
      formValues: {},
      reasonGet: Reason.get("type eq 'RESCHEDULED'"),
      disabled: true,
    }
  },
  computed: {
    rescheduledStatusLabel() {
      return this.newStatusTransition?.status?.label || this.$t('delivery.status.rescheduled')
    },
    rescheduleWarningHtml() {
      return this.$t('delivery.message.rescheduleWarning')
    },
    confirmationHtml() {
      if (this.isFromList) {
        return this.$t('delivery.message.confirmRescheduleSelectedData', {
          count: `<strong>${this.selectedIds.length}</strong>`,
        })
      }

      return this.$t('delivery.message.confirmRescheduleDeliveryNumber', {
        number: `<strong>${this.entityData.number}</strong>`,
      })
    },
    statusChangeHtml() {
      if (this.isFromList) {
        return this.$t('delivery.message.statusWillChangeToRescheduled', {
          status: this.rescheduledStatusLabel,
        })
      }

      return this.$t('delivery.message.statusWillChangeToRescheduledAndRemovedFromFleetTask', {
        status: this.rescheduledStatusLabel,
        fleetTaskNumber: this.entityData?.fleet_task?.number
          ? `<strong>${this.entityData.fleet_task.number}</strong>`
          : '-',
      })
    },
  },
  watch: {
    formValues: {
      handler() {
        const reasonId = this.formValues['reason-id']

        this.disabled = reasonId === null || reasonId === undefined
      },
      deep: true,
    },
  },
  methods: {
    triggerSubmit() {
      this.$formulate.submit('reason-form')
    },
    handleSubmit(data) {
      this.$emit('transition', {
        transition: this.newStatusTransition,
        additionalPayload: {
          fields: {
            rescheduled_reason_id: data['reason-id'],
          },
        },
      })
    },
    handleFailedValidation(_field) {
      this.$mcToast.error(this.$t('global.inputFormatError'))
    },
    // NOTE:
    // This function will be called from parents,
    // Ideally we capitalized the first letter of the function name
    // but the name are kept as 'show' and 'hide' to match bootstrap's convention
    // of modal 'show' and 'hide' function
    show() {
      this.$refs['mc-modal'].show()
    },
    hide() {
      this.$refs['mc-modal'].hide()
    },
  },
}
</script>

<style>
.__transition-icon {
  font-size: 20px;
  vertical-align: middle;
  margin: 0 10px;

  &::before {
    color: #4a90e1;
  }
}

strong {
  font-weight: bold;
}
</style>
